import axios from 'axios';
import { adminAuth } from './adminAuth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = adminAuth.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      adminAuth.logout();
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const adminApi = {
  getDashboard: () => api.get('/dashboard').then(r => r.data),
  getReservations: (params) => api.get('/reservations', { params }).then(r => r.data),
  getReservation: (id) => api.get(`/reservations/${id}`).then(r => r.data),
  getSchools: () => api.get('/schools').then(r => r.data),
  getPickups: () => api.get('/pickups').then(r => r.data),
  getDeliveries: () => api.get('/deliveries').then(r => r.data),
  getInventory: () => api.get('/inventory').then(r => r.data),
  getMovers: () => api.get('/movers').then(r => r.data),
  getVehicles: () => api.get('/vehicles').then(r => r.data),
  getPayments: () => api.get('/payments').then(r => r.data),
  getSupportTickets: () => api.get('/support-tickets').then(r => r.data),
  getTeam: () => api.get('/team').then(r => r.data),
  markDepositPaid: (id) => api.post('/workflow/mark-deposit-paid', { reservation_id: id }).then(r => r.data),
  updatePickupStatus: (id, status) => api.post('/workflow/update-pickup-status', { pickup_id: id, status }).then(r => r.data),
  updateDeliveryStatus: (id, status) => api.post('/workflow/update-delivery-status', { delivery_id: id, status }).then(r => r.data),
  assignMover: (pickupId, moverId) => api.post('/workflow/assign-mover', { pickup_id: pickupId, mover_id: moverId }).then(r => r.data),
  assignVehicle: (pickupId, vehicleId) => api.post('/workflow/assign-vehicle', { pickup_id: pickupId, vehicle_id: vehicleId }).then(r => r.data),
  updateSchoolWindows: (schoolId, data) => api.post('/workflow/update-school-windows', { school_id: schoolId, ...data }).then(r => r.data),
  updateTicketStatus: (ticketId, status, assigned_to) => api.post('/workflow/update-ticket-status', { ticket_id: ticketId, status, assigned_to }).then(r => r.data),
  addTeamMember: (member) => api.post('/workflow/add-team-member', member).then(r => r.data),
  addInternalNote: (reservationId, note) => api.post('/workflow/add-internal-note', { reservation_id: reservationId, note }).then(r => r.data),
};
